"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchOptimizedTopics = fetchOptimizedTopics;
exports.fetchTopics = fetchTopics;
exports.getBugStatuses = getBugStatuses;
exports.getIdeaStatuses = getIdeaStatuses;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

function getIdeaStatuses() {
  return _getIdeaStatuses.apply(this, arguments);
}

function _getIdeaStatuses() {
  _getIdeaStatuses = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var _yield$axios$get, data;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.get('/community/api/ideas/ideaStatuses');

          case 2:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            return _context.abrupt("return", data.result);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getIdeaStatuses.apply(this, arguments);
}

function getBugStatuses() {
  return _getBugStatuses.apply(this, arguments);
}

function _getBugStatuses() {
  _getBugStatuses = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var _yield$axios$get2, data;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _axios.default.get('/community/api/contentStatuses', {
              params: {
                context: 'bug'
              }
            });

          case 2:
            _yield$axios$get2 = _context2.sent;
            data = _yield$axios$get2.data;
            return _context2.abrupt("return", data.map(function (status) {
              return {
                id: String(status.id),
                name: status.name,
                backgroundColor: status.backgroundColor,
                textColor: status.textColor
              };
            }));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getBugStatuses.apply(this, arguments);
}

function fetchTopics(_x, _x2) {
  return _fetchTopics.apply(this, arguments);
}

function _fetchTopics() {
  _fetchTopics = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(requestUrl, query) {
    var _yield$axios$post, data, topics, total, authors;

    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _axios.default.post(requestUrl, query);

          case 2:
            _yield$axios$post = _context3.sent;
            data = _yield$axios$post.data;
            topics = data.topics, total = data.total, authors = data.authors;
            return _context3.abrupt("return", {
              topics: topics,
              total: total,
              authors: authors
            });

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchTopics.apply(this, arguments);
}

function fetchOptimizedTopics(_x3, _x4) {
  return _fetchOptimizedTopics.apply(this, arguments);
}

function _fetchOptimizedTopics() {
  _fetchOptimizedTopics = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(requestUrl, query) {
    var stripHtmlFromContent,
        trimContentLength,
        requestBody,
        _yield$axios$post2,
        data,
        topics,
        total,
        authors,
        _args4 = arguments;

    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            stripHtmlFromContent = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : false;
            trimContentLength = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : 0;
            requestBody = {
              topicQuery: query,
              stripHtmlFromContent: stripHtmlFromContent,
              trimContentLength: trimContentLength
            };
            _context4.next = 5;
            return _axios.default.post(requestUrl, requestBody);

          case 5:
            _yield$axios$post2 = _context4.sent;
            data = _yield$axios$post2.data;
            topics = data.topics, total = data.total, authors = data.authors;
            return _context4.abrupt("return", {
              topics: topics,
              total: total,
              authors: authors
            });

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _fetchOptimizedTopics.apply(this, arguments);
}